if (!customElements.get('utility-rebate-finder')) {
  class UtilityRebateFinder extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputBox = this.querySelector('.zip-search');
      this.searchBtn = this.querySelector('.zip-submit');
      this.optionsWrapper = this.querySelector('.utility-option-selection');
      this.resultWrapper = this.querySelector('.utility-results');
      this.resultItemsWrapper = this.querySelector('.utility-result__items');
      this.noResultWrapper = this.querySelector('.utility-no-results');
      this.noOptionLink = this.querySelector('.no-option-link');
      this.radioButtons = this.querySelectorAll('input[name="utility-select"]');
      this.zipWarning = this.querySelector('.utility-zip__warning');
      this.radios = this.querySelectorAll('input[type="radio"][name="utility-select"]');
      this.totalResultEle = this.querySelector('.utility-results__count');
      this.apiEndPoint = this.getAttribute('data-api-url');
      
      if (this.inputBox) {
        this.inputBox.addEventListener('input', this.handleTyping.bind(this));

        this.inputBox.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            this.handleSubmit(e);
          }
        });
      }

      if (this.searchBtn) {
        this.searchBtn.addEventListener('click', this.handleSubmit.bind(this));
      }

      if (this.noOptionLink) {
        this.noOptionLink.addEventListener('click', (e) => {
          this.resetRadios(e);
          //this.resultWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const targetSection = document.querySelector('.cc-faq');
          console.log('scroll running');
          if (targetSection) {
            console.log('targetSection found');
            targetSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
          this.handleApiCall();
        });
      }

      if (this.radioButtons.length > 0) {
        this.radioButtons.forEach(radio => {
          radio.addEventListener('change', this.handleOptionChange.bind(this));
        });
      }
    }

    handleTyping(evt) {
      const zipCode = this.inputBox?.value?.trim() || '';

      this.zipWarning.style.display = "none";
      if (zipCode.length < 5) {
        this.optionsWrapper.classList.add('disabled--options');
        this.noOptionLink.classList.remove('no-option--active');
        this.resetRadios(evt);
      }
    }

    handleSubmit(evt) {
      evt.preventDefault();
      const zipCode = this.inputBox?.value?.trim() || '';

      this.radios.forEach(radio => radio.checked = false);
    
      this.noResultWrapper.style.display = "none";
      this.resultItemsWrapper.innerHTML = `
        <li class="utility-result__item">
          Complete the Step One and Two to view energy providers near you who offer thermostats rebates and incentives.
        </li>
      `;

      if (zipCode.length < 5) {
        console.warn('Invalid zip code. Must be at least 5 digits.');
        this.zipWarning.style.display = "block";
        this.optionsWrapper.classList.add('disabled--options');
        this.totalResultEle.style.display="none";
        return;
      }

      this.optionsWrapper.classList.remove('disabled--options');
      //this.optionsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      console.log('scroll running');

      const anchor = document.querySelector('.utility-step');

      if (anchor) {

        console.log('anchor found');

        setTimeout(() => {

          const top =
            anchor.getBoundingClientRect().top +
            window.pageYOffset +
            40;

          window.scrollTo({
            top,
            behavior: 'smooth'
          });

        }, 300);
      }
      console.log('Valid zip code:', zipCode);
    }

    handleOptionChange(evt) {
      console.log("option changed");
      this.noOptionLink.classList.remove('no-option--active');
      //this.resultWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const anchor = document.querySelector('.utility-results');
      console.log('scroll running', anchor);

      if (anchor) {
        console.log('rebate anchor found');

        const offset = -100;

        const top =
          anchor.getBoundingClientRect().top +
          window.pageYOffset +
          offset;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
      this.handleApiCall(evt);
    }

    resetRadios(evt) {
      this.radios.forEach(radio => radio.checked = false);
      if (evt.type !== 'input') {
        this.noOptionLink.classList.add('no-option--active');
      }
    }

    async handleApiCall(evt) {
      const apiURL = this.apiEndPoint;
      const selectedRadio = this.querySelector('input[name="utility-select"]:checked');
      const selectedOption = selectedRadio ? selectedRadio.value : 'all';
      const zipCode = this.inputBox?.value || '';

      const headers = {
        'api-key': selectedOption,
        'zip-code': zipCode
      };

      try {
        const response = await fetch(apiURL, { headers });
        const data = await response.json();

        if (Array.isArray(data) && data.length > 0) {
          console.log("Found results", data);
          this.noResultWrapper.style.display = "none";
          this.totalResultEle.querySelector('.number').innerHTML = data.length;
          this.totalResultEle.querySelector('.zip').innerHTML = zipCode;
          this.totalResultEle.style.display = "block";
          this.resultItemsWrapper.innerHTML = '';

          data.forEach(item => {
            this.resultItemsWrapper.insertAdjacentHTML('beforeend', `
              <hr class="item-divider">
              <li class="utility-result__item">
                <div class="result-info">
                  <p class="result-info__title">${item.SERVICE_TITLE}</p>
                  <p class="result-info__description">${item.CUSTOM_FIELD_1}</p>
                </div>
                <div class="result-buttons">
                  <a href="${item.URL}" class="result-buttons__btn btn btn--primary">View Offer</a>
                  <a href="${item.URL}" class="result-buttons__link">Learn More About Rebates</a>
                </div>
              </li>
            `);
          });
        } else {
          console.log("No results found");
          this.resultItemsWrapper.innerHTML = '';
          this.noResultWrapper.style.display = "block";
          this.totalResultEle.style.display = "none";
          this.noResultWrapper.querySelector('.input-zip-code').innerHTML = `"${zipCode}"`;
        }
      } catch (error) {
        console.error("API call failed:", error);
        this.resultItemsWrapper.innerHTML = `<li class="utility-result__item">An error occurred while fetching data.</li>`;
      }
    }
  }

  customElements.define('utility-rebate-finder', UtilityRebateFinder);
}
